import { Btn } from '../components/ui/Btn';
import { irA } from '../lib/ruta';
import { textos } from '../textos';

/** Ruta aparte del menú de la empresa. Sólo la usa quien opera la plataforma. */
export function PlatformShell(props: {
  readonly children: React.ReactNode;
  readonly onCerrar: () => void;
}): React.JSX.Element {
  return (
    <div className="flex min-h-dvh flex-col bg-brand-surface-2" translate="no">
      <header className="flex items-center gap-4 border-b border-brand-border bg-brand-primary px-6 py-3 text-brand-primary-fg">
        <p className="text-xl font-semibold tracking-tight">{textos.app.nombre}</p>
        <p className="text-sm">{textos.nav.plataforma}</p>
        <button
          type="button"
          className="min-h-tactil ml-auto rounded-brand px-3 text-sm underline-offset-2 hover:underline"
          onClick={() => irA('/')}
        >
          {textos.plataforma.volver}
        </button>
        <Btn variante="secundario" onClick={props.onCerrar}>
          {textos.acciones.cerrarSesion}
        </Btn>
      </header>
      <main className="flex-1 overflow-auto p-6">{props.children}</main>
    </div>
  );
}
